import { motion } from 'motion/react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const variants = cva(
  'fixed bottom-5 md:bottom-8 right-5 md:right-8 w-fit rounded-lg z-50 py-1.5 px-2.5 text-13',
  {
    variants: {
      theme: {
        default: 'bg-black text-white',
        primary: 'bg-primary-500 text-white',
      },
    },
    defaultVariants: {
      theme: 'default',
    },
  },
)

type ToastProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof variants> & {
    theme?: 'default' | 'primary'
  }

export default function Toast({ theme, className, children }: ToastProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className={cn(variants({ theme, className }))}
    >
      {children}
    </motion.div>
  )
}
